import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from 'react';
import { createClient } from '@reservoir0x/relay-sdk';
import { UI_VERSION } from '../version.js';
export const RelayClientContext = createContext(null);
export const RelayClientProvider = function ({ children, options }) {
    const [clientContext] = useState(createClient({ ...options, uiVersion: UI_VERSION }));
    return (_jsx(RelayClientContext.Provider, { value: clientContext, children: children }));
};
//# sourceMappingURL=RelayClientProvider.js.map